export enum CreditsRolloverModesEnum {
  DOWNGRADE_WITH_ROLLOVER = 'downgrade_with_rollover',
  DOWNGRADE_WITHOUT_ROLLOVER = 'downgrade_without_rollover',
  SWITCH = 'switch'
}
